<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="me_title">
            <label class="weui-form-preview__label">{{
              customLabel.me_title || "会议议题"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.me_title
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="me_date">
            <label class="weui-form-preview__label">{{
              customLabel.me_date || "会议日期"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ dateFormat(form.main.me_date, "yyyy-MM-dd") }}
              {{ form.main.me_start }} ~ {{ form.main.me_over }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="me_mrname">
            <label class="weui-form-preview__label">{{
              customLabel.me_mrname || "会议室"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.me_mrname }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="me_address">
            <label class="weui-form-preview__label">{{
              customLabel.me_address || "地点"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.me_address }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="me_emnames">
            <label class="weui-form-preview__label">{{
              customLabel.me_emnames || "参会人员"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.me_emnames }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="me_content">
            <label class="weui-form-preview__label">{{
              customLabel.me_content || "会议纪要"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.me_content }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="me_remind">
            <label class="weui-form-preview__label">{{
              customLabel.me_remind || "提醒设置"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ getRemind(form.main.me_remind) }}
            </span>
          </div>
        </custom-layout>
      </div>
      <file-list :value="form.main.me_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/meeting_edit?id=' + form.main.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    FileList,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/meeting",
      codeField: "me_code",
      caller: "Meeting",
      xtype: "oa-meeting-formpanel",
    };
  },
  methods: {
    p_remove() {
      const me = this;
      me.$weui.confirm("确定删除单据？", function () {
        me.$loading({
          url: `/api/oa/meeting/delete/${me.form.main.id}?caller=Meeting`,
          method: "POST",
        }).then((res) => {
          if (res.success) {
            me.$router.push("/oa/meet");
          }
        });
      });
    },
    getRemind(value) {
      if (value == null) {
        return '不提醒'
      }
      switch (value) {
        case 0:
          return "会议开始前";
        case 5:
          return "5分钟前";
        case 15:
          return "15分钟前";
        case 30:
          return "30分钟前";
        case 60:
          return "1小时前";
        case 1440:
          return "1天前";
        default:
          return "不提醒";
      }
    }
  },
};
</script>